import {
  IDefenseDeviceFilterProps,
  IDefenseDeviceProps,
  IDefenseDeviceSimpleProps,
} from './types';
import { api } from '../../DefaultService';
import { IPaginationParams } from '../../types';

const ENDPOINT = '/v1/devices/defense';

export const getAllDefenseDevicesByLicenseCountAsync = async (
  filter: IDefenseDeviceFilterProps,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getDefenseDeviceByIdAsync = async (
  id: number,
): Promise<IDefenseDeviceProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const synchronizeDevicesByLicenseAsync = async (): Promise<boolean> => {
  return await api
    .put(`${ENDPOINT}/synchronize`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllDefenseDevicesByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: IDefenseDeviceFilterProps,
): Promise<IDefenseDeviceSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
